import { BreadCrumb } from "primereact/breadcrumb";
import { useEffect, useRef, useState } from "react";
import AdmissionRequestService from "../../../api/AdmissionRequestService";
import { Toast } from "primereact/toast";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import EmptyMessage from "../../../components/datatable/EmptyMessage";
import { FilterMatchMode, FilterOperator } from "primereact/api";
import SearchComponent from "../../../components/datatable/SearchComponent";
import ActionBtn from "../../../components/dashboard/btn/ActionBtn";
import { Button } from "primereact/button";
import { MegaMenu } from "primereact/megamenu";
import { Tag } from "primereact/tag";
import { useNavigate } from "react-router-dom";
import { routes } from "../../../routes";
import { Chip } from "primereact/chip";
import BranchService from "../../../api/BranchService";
import { ProgressSpinner } from "primereact/progressspinner";
import { TextInput } from "../../../components/formLibs/FormLibs";
import { Dialog } from "primereact/dialog";
import { Dropdown } from "primereact/dropdown";
import { ErrorMsg } from "../../../components/includes/styles/Styles";
import useAuth from "../../../hooks/useAuth";

export default function Candidates() {
  const navigate = useNavigate();
  const { auth } = useAuth();

  const adminPermissions = [
    "gerer_candidatures",
    "gerer_admissions",
    "gerer_parcours",
    "gerer_sites_ou_campus_admission",
    "gerer_outils_tests_developpement_personnel",
    "gerer_utilisateurs_roles_permissions",
    "generer_rapports_statistiques_candidatures",
  ];
  const items = [{ label: "Candidatures" }, { label: "Liste" }];
  const candidate = { icon: "pi pi-wallet", url: "/dashboard/candidates" };
  const [admissionRequests, setAdmissionRequests] = useState([]);
  const [admissionRequest, setAdmissionRequest] = useState(null);
  const [filters, setFilters] = useState({
    global: { value: null, matchMode: FilterMatchMode.CONTAINS },
    //name: { value: null, matchMode: FilterMatchMode.STARTS_WITH }
  });
  const [openSaveModal, setOpenSaveModal] = useState(false);
  const [selectionNumber, setSelectionNumber] = useState("");
  const [selectionSite, setSelectionSite] = useState("");
  const [selectionTraining, setSelectionTraining] = useState("");
  const [formations, setFormations] = useState([]);
  const [sites, setSites] = useState([]);
  const [globalFilterValue, setGlobalFilterValue] = useState("");
  const onGlobalFilterChange = (e) => {
    const value = e.target.value;
    let _filters = { ...filters };
    _filters["global"].value = value;

    setFilters(_filters);
    setGlobalFilterValue(value);
  };
  const toast = useRef(null);
  const [loading, setLoading] = useState(true);
  const [refresh, setRefresh] = useState(true);

  useEffect(() => {
    AdmissionRequestService.getAll()
      .then((res) => {
        setAdmissionRequests(res.data.admissionRequests);
        setLoading(false);
      })
      .catch((err) => console.log("err", err));
    BranchService.getAll().then((res) => {
      console.log("res", res);
      setSites(res.data.branches);
    });
  }, []);
  const header = () => {
    return (
      <div className="flex justify-content-between">
        {auth?.permissions?.find((permission) =>
                adminPermissions.includes(permission?.name)
              )&&<Button
          color="#fff"
          label="Terminer ce niveau"
          onClick={() => setOpenSaveModal(true)}
        />}
        <SearchComponent
          globalFilterValue={globalFilterValue}
          onGlobalFilterChange={onGlobalFilterChange}
        />
      </div>
    );
  };
  const actionTemplate = (rowData) => {
    return (
      <div className="flex justify-content-start gap-3 align-items-center">
        <ActionBtn
          icon="pi pi-eye"
          severity="primary"
          tooltip="Consulter"
          handleClick={() =>
            navigate(routes.dashboard.candidates.path + `/${rowData.id}`)
          }
        />
      </div>
    );
  };

  const handleSaveStep = (e) => {
    e.preventDefault();
    setLoading(true);
    if (!selectionNumber || !selectionSite || !selectionTraining) {
      setLoading(false);
      alert(
        "Veuillez entrer le nombre de dossier à selectionner et chosir un campus et un parcours svp"
      );
    } else {
      let canSave = true;
      if (admissionRequests[0].level == 0) {
        admissionRequests.forEach((element) => {
          if (element.average_preselection == 0) {
            canSave = false;
          }
        });
        if (canSave) {
          const data = {
            selectionNumber: selectionNumber,
            step: 0,
            branche_id: selectionSite.id,
            training_id: selectionTraining.id,
          };
          AdmissionRequestService.saveStep(data)
            .then((res) => {
              setSelectionNumber("");
              setSelectionSite("");
              selectionTraining("");
              setOpenSaveModal(false);
              setRefresh(!refresh);
              setLoading(false);
              toast.current.show({
                severity: "success",
                summary: "Succès",
                detail:
                  "Vous aviez terminé la préselection avec succès. Passez à l'étape suivante",
                life: 1500,
              });
            })
            .catch((err) => {
              console.log("err", err);
              if (err.code === 404) {
                toast.current.show({
                  severity: "danger",
                  summary: "Erreur",
                  detail: `Il y a aucune candidature en attente pour le parcours ${selectionTraining?.name} sur le sitede ${setSelectionSite?.name}`,
                  life: 4000,
                });
              } else {
                toast.current.show({
                  severity: "danger",
                  summary: "Erreur",
                  detail: `Vous ne pouviez pas encore terminer cette étape. Veuillez vérifier si vous aviez traiter toutes las candidatures concernant le parcours ${selectionTraining?.name} sur le sitede ${setSelectionSite?.name}`,
                  life: 4000,
                });
              }
              setLoading(false);
            });
        } else {
          setOpenSaveModal(false);
          setLoading(false);
          alert("Veuillez traiter tous les dossiers svp !");
        }
      } else if (admissionRequests[0].level == 1) {
        admissionRequests.forEach((element) => {
          if (element.average_interview == 0) {
            canSave = false;
          }
        });
        if (canSave) {
          const data = {
            selectionNumber: selectionNumber,
            step: 1,
            branche_id: selectionSite.id,
            training_id: selectionTraining.id,
          };
          AdmissionRequestService.saveStep(data)
            .then((res) => {
              setSelectionNumber("");
              setSelectionSite("");
              selectionTraining("");
              setOpenSaveModal(false);
              setRefresh(!refresh);
              setLoading(false);
              toast.current.show({
                severity: "success",
                summary: "Succès",
                detail:
                  "Vous aviez terminé les entretiens avec succès. Passez à l'étape suivante",
                life: 1500,
              });
            })
            .catch((err) => {
              console.log("err", err);
              if (err.code === 404) {
                toast.current.show({
                  severity: "danger",
                  summary: "Erreur",
                  detail: `Il y a aucune candidature en attente pour le parcours ${selectionTraining?.name} sur le sitede ${setSelectionSite?.name}`,
                  life: 4000,
                });
              } else {
                toast.current.show({
                  severity: "danger",
                  summary: "Erreur",
                  detail: `Vous ne pouviez pas encore terminer cette étape. Veuillez vérifier si vous aviez traiter toutes las candidatures concernant le parcours ${selectionTraining?.name} sur le sitede ${setSelectionSite?.name}`,
                  life: 4000,
                });
              }
              setLoading(false);
            });
        } else {
          setOpenSaveModal(false);
          setLoading(false);
          alert("Veuillez traiter tous les dossiers svp !");
        }
      } else {
        admissionRequests.forEach((element) => {
          if (element.average_challenge == 0) {
            canSave = false;
          }
        });
        if (canSave) {
          const data = {
            selectionNumber: selectionNumber,
            step: 2,
            branche_id: selectionSite.id,
            training_id: selectionTraining.id,
          };
          AdmissionRequestService.saveStep(data)
            .then((res) => {
              setSelectionNumber("");
              setSelectionSite("");
              selectionTraining("");
              setOpenSaveModal(false);
              setRefresh(!refresh);
              setLoading(false);
              toast.current.show({
                severity: "success",
                summary: "Succès",
                detail:
                  "Vous aviez terminé la prairie avec succès. Rendez-vous en classe",
                life: 1500,
              });
            })
            .catch((err) => {
              console.log("err", err);
              if (err.code === 404) {
                toast.current.show({
                  severity: "danger",
                  summary: "Erreur",
                  detail: `Il y a aucune candidature en attente pour le parcours ${selectionTraining?.name} sur le sitede ${setSelectionSite?.name}`,
                  life: 4000,
                });
              } else {
                toast.current.show({
                  severity: "danger",
                  summary: "Erreur",
                  detail: `Vous ne pouviez pas encore terminer cette étape. Veuillez vérifier si vous aviez traiter toutes las candidatures concernant le parcours ${selectionTraining?.name} sur le sitede ${setSelectionSite?.name}`,
                  life: 4000,
                });
              }
              setLoading(false);
            });
        } else {
          setOpenSaveModal(false);
          setLoading(false);
          alert("Veuillez traiter tous les dossiers svp !");
        }
      }
    }
  };

  return (
    <div className="pl-2 pr-2">
      <Toast ref={toast} />
      <BreadCrumb model={items} home={candidate} />
      <Dialog
        header="Terminer cette étape"
        visible={openSaveModal}
        style={{ width: "50vw" }}
        onHide={() => setOpenSaveModal(false)}
      >
        <form className="form" onSubmit={handleSaveStep}>
          <div className="form__item">
            <label htmlFor="name">Nombre de dossier à sélectionner</label>
            <div className="form__item__ic_p">
              <TextInput
                type="number"
                name="name"
                label="name"
                handleChange={(e) => setSelectionNumber(e.target.value)}
                // register={register}
              />
            </div>
          </div>
          <div className="form__item">
            <label htmlFor="site">Site</label>
            <div className="form__item__ic_p">
              <Dropdown
                value={selectionSite}
                onChange={(e) => {
                  console.log(e.value.training_programs, "e");
                  setSelectionSite(e.value);
                  setFormations(e.value.training_programs);
                }}
                options={sites}
                optionLabel="name"
                placeholder="Sectionner un site"
                className="w-full"
              />
            </div>
          </div>
          {formations.length > 0 && (
            <div className="form__item">
              <label htmlFor="formation">Parcours</label>
              <div className="form__item__ic_p">
                <Dropdown
                  value={selectionTraining}
                  onChange={(e) => setSelectionTraining(e.value)}
                  options={formations}
                  optionLabel="name"
                  placeholder="Sectionner un parcours"
                  className="w-full"
                />
              </div>
            </div>
          )}
          <div className="form__item">
            <button type="submit">
              Enregistrer{" "}
              <ProgressSpinner
                style={
                  loading
                    ? { width: "20px", height: "20px" }
                    : { width: "0px", height: "0px" }
                }
                strokeWidth="8"
                loading={loading}
              />
            </button>
          </div>
        </form>
      </Dialog>
      <div className="">
        <DataTable
          value={admissionRequests}
          tableStyle={{ minWidth: "50rem" }}
          paginator
          rows={5}
          rowsPerPageOptions={[5, 10, 25, 50]}
          dataKey="id"
          filters={filters}
          loading={loading}
          //globalFilterFields={["name"]}
          header={header}
          emptyMessage={EmptyMessage}
        >
          <Column
            body={(rowData) =>
              rowData.user.lastname + " " + rowData.user.firstname
            }
            header="Candidat"
            style={{ width: "20%" }}
          ></Column>

          <Column
            body={(rowData) =>
              rowData.branche_training_program?.branche?.name +
              " - " +
              rowData.branche_training_program?.training_program?.name
            }
            header="Site - Parcours"
            //style={{ width: "20%" }}
          ></Column>

          <Column
            field="statut"
            header="Statut"
            body={(rowData) =>
              rowData.status == 1 ? (
                <Tag severity="info" value="En cours"></Tag>
              ) : (
                <Tag severity="success" value="Traité"></Tag>
              )
            }
            style={{ width: "20%" }}
          ></Column>
          <Column
            header="Niveau"
            //style={{ width: "10%" }}
            body={(rowData) =>
              rowData.level == 0 ? (
                <Chip label="Preselection"></Chip>
              ) : rowData.level == 1 ? (
                <Chip label="Entretien"></Chip>
              ) : (
                <Chip label="Prairie"></Chip>
              )
            }
          ></Column>
          <Column
            field="average_preselection"
            header="Moyenne Préselection / 20"
            style={{ width: "10%" }}
          ></Column>
          <Column
            field="average_interview"
            header="Moyenne Entretien / 20"
            style={{ width: "10%" }}
          ></Column>
          <Column
            field="average_challenge"
            header="Moyenne Prairie / 20"
            style={{ width: "10%" }}
          ></Column>
          <Column
            header="Action"
            body={actionTemplate}
            style={{ width: "30%" }}
          ></Column>
        </DataTable>
      </div>
    </div>
  );
}
